import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ROUTES_CONFIG } from "@/config/routes.config";
import { convertNumberToMarketValue } from "@/lib/utils";
import { useTRPC } from "@/trpc";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useTypedParams } from "react-router-typesafe-routes";

const Players = () => {
  const navigate = useNavigate();
  const { trpc } = useTRPC();
  const { club_id } = useTypedParams(ROUTES_CONFIG.APP.CLUB_DETAIL);

  const { data: club } = useQuery({
    queryKey: ["club", club_id],
    queryFn: async () => {
      const club = await trpc.clubs.getById.query({
        club_id: club_id,
        with_players: true
      });
      return club;
    },
  });

  const playerRows =
    club && "players" in club && Array.isArray((club as any).players)
      ? (club.players)
      : [];

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>#</TableHead>
          <TableHead>Naam</TableHead>
          <TableHead>Positie</TableHead>
          <TableHead>Geboortedatum</TableHead>
          <TableHead>Nat.</TableHead>
          <TableHead>Marktwaarde</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {playerRows.map((player) => (
          <TableRow>
            <TableCell>{player?.shirtNumber || "-"}</TableCell>
            <TableCell
              className="group/name cursor-pointer"
              onClick={() => {
                if (player?.id === undefined) return;
                navigate(
                  ROUTES_CONFIG.APP.PLAYER_DETAIL.$buildPath({
                    params: { player_id: player?.id },
                  })
                );
              }}
            >
              <div className="flex items-center gap-2">
                <div className="size-8 aspect-square rounded-full bg-foreground/10">
                  <Avatar>
                    <AvatarImage
                      src={player?.imageUrl ?? undefined}
                      alt={player?.name ?? undefined}
                    />
                    <AvatarFallback>{player?.name?.charAt(0)}</AvatarFallback>
                  </Avatar>
                </div>
                <p className="group-hover/name:underline font-medium">
                  {player?.name || "-"}
                </p>
              </div>
            </TableCell>
            <TableCell>{player?.positionMain || "-"}</TableCell>
            <TableCell>
                {player?.dateOfBirth} {player?.age ? `(${player?.age})` : "-"}
            </TableCell>
            <TableCell>{player?.citizenship?.join(", ")}</TableCell>
            <TableCell>
              {convertNumberToMarketValue(player?.marketValue)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default Players;
